import { api } from "_endpoints/api";
import http from "../axios";

//add tradesman
export function addTradesman(payload) {
  return http.post(api.tradesman.addTradesman, payload);
}
//update tradesman
export function updateTradesman(payload) {
  return http.post(api.tradesman.updateTradesman, payload);
}
//resend tradesperson invitation email
export function resendTradesmanInvite(tradesmanId) {
  return http.post(api.tradesman.resendTradesmanInvite, { tradesmanId });
}
//view all tradesmans
export function viewAllTradesmans() {
  return http.get(api.tradesman.viewAllTradesman);
}
//view all tradesmans - Paginated with search
export function viewAllTradesmansPaginated(page = 0, limit = 25, search = "") {
  return http.get(api.tradesman.viewAllTradesmanPaginated, {
    params: { page, limit, search },
  });
}
export function getLandlords() {
  return http.get(api.tradesman.getLandlords);
}
//check tradesperson email
export function checkTradesmanEmail(email) {
  return http.get(api.tradesman.checkTradesmanEmail(email));
}
//view all unassgined  tradesmans
export function viewUnassignedTradesman(ticketId) {
  return http.get(api.tradesman.viewUnassignedTradesman(ticketId));
}
//delete tradesman
export function deleteTradesman(tradesmanId, deletionReason) {
  return http.post(api.tradesman.deleteTradesman(tradesmanId), { reason: deletionReason });
}
//delete tradesman
export function getSingleTradeperson(tradesmanId) {
  return http.get(api.tradesman.getsingleTradesman(tradesmanId));
}
